import { useAppSelector } from "integrations/redux/hooks"
import { selectActiveSidePanelModal } from "panels/content/side-panel/slice"
import { IconImagePreviewContainer } from "./Toolbox/Icons/IconImagePreviewContainer"
/**
 * emulates the pattern of the panel provider, but for specific plugins
 * @todo - in the future, come up with a way to allow dynamic registration of the plugins via standard interface, which should provide a list of allowable runlevels
 */
export function PluginProvider() {
    const activeSidePanelModal = useAppSelector(selectActiveSidePanelModal())

    if (!activeSidePanelModal || activeSidePanelModal.type !== "layer") return null

    const flightId = activeSidePanelModal?.id

    switch (activeSidePanelModal.layerContentType) {
        case "iconimage":
            return <IconImagePreviewContainer iconId={flightId} />
        default:
            console.warn("PluginProvider: Invalid layer content type was provided.")
            return null
    }
}

export const useFlightIdInfo = (flightId: string) => {
    const activeSidePanelModal = useAppSelector(selectActiveSidePanelModal())
    if (!activeSidePanelModal || !flightId || activeSidePanelModal.type !== "layer")
        return { activeSidePanelFlight: false }
    const activeFlightId = activeSidePanelModal.id
    return { activeSidePanelFlight: activeFlightId === flightId }
}
